var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_794",
    "data-name": "Raggruppa 794",
    transform: "translate(-89 -456)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Componente_63_1",
    "data-name": "Componente 63 \\u2013 1",
    transform: "translate(89 456)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_603",
    "data-name": "Raggruppa 603",
    transform: "translate(-473 -481)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_602",
    "data-name": "Raggruppa 602"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_601",
    "data-name": "Raggruppa 601"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Componente_62_1",
    "data-name": "Componente 62 \\u2013 1",
    transform: "translate(473 481)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_11",
    "data-name": "Ellisse 11",
    cx: 13,
    cy: 13,
    r: 13,
    fill: "#1ad598"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_230",
    "data-name": "Tracciato 230",
    d: "M54.193,274.4l-3.17-3.189a1.282,1.282,0,0,1,0-1.8,1.264,1.264,0,0,1,1.793,0l2.273,2.287,6.075-6.114a1.264,1.264,0,0,1,1.793,0,1.282,1.282,0,0,1,0,1.8L55.985,274.4a1.26,1.26,0,0,1-1.792,0Z",
    transform: "translate(429 224)",
    fill: "#fff",
    fillRule: "evenodd"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckGreen);
export default __webpack_public_path__ + "static/media/check-green.d0c840aad0705a6541632305ab9a0fd8.svg";
export { ForwardRef as ReactComponent };